module.exports = __webpack_public_path__ + "img/d36d47e.png";